import { RouteConfig } from 'vue-router';
import Form from '@/views/layout/Form.vue';
import i18n from '@/i18n';

const routes: Array<RouteConfig> = [
  {
    path: 'community',
    name: 'community',
    component: Form,
    redirect: { name: 'community-list' },
    meta: {
      session: true,
    },
    children: [
      {
        path: 'list',
        name: 'community-list',
        component: () => import('@/views/community/CommunityList.vue'),
        meta: {
          header: {
            label: () => i18n.tc('community.label', 2),
          },
        },
      },
      {
        path: 'create',
        name: 'community-create',
        component: () => import('@/views/community/CommunityCreate.vue'),
        meta: {
          header: {
            route: { name: 'community-list' },
            label: () =>
              i18n.t('title.create', [i18n.tc('community.label', 2)]),
          },
        },
      },
      {
        path: 'edit/:id(\\d+)',
        name: 'community-edit',
        component: () => import('@/views/community/CommunityEdit.vue'),
        meta: {
          header: {
            route: { name: 'community-list' },
            label: () => i18n.t('title.edit', [i18n.tc('community.label', 2)]),
          },
        },
      },
    ],
  },
];

export default routes;
